import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
// @hello-pangea/dnd is a maintained version of react-beautiful-dnd
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { Card, Paper, CardHeader, CardContent, Grid, styled, } from '@mui/material';
import UploadCard from './UploadCard';
import PhotoCard from './PhotoCard';
;
const StyledCard = styled(Card) `
${({ isLoading }) => isLoading &&
    `&> * {
    pointer-events: none;
 }
`}`;
const UploadedPhotosCard = ({ hasUploadError = false, isLoading = false, imageUrls: initialImageUrls = {}, onFileAdd, handleDrag, handleReorder, onImageDelete, dragActive, }) => {
    // to help with reordering the drag-result
    const reorderNestedObject = (list, oldIndex, newIndex) => {
        const result = Object.values(list);
        const [removed] = result.splice(oldIndex, 1);
        result.splice(newIndex, 0, removed);
        return result.reduce((obj, value, index) => {
            obj[index] = value;
            return obj;
        }, {});
    };
    const PhotoHolder = ({ hasError }) => {
        const [imageUrls, setImageUrls] = React.useState(initialImageUrls);
        const handleDragEnd = (result) => {
            if (!result.destination)
                return;
            if (result.destination.index === result.source.index)
                return;
            const newImageUrls = reorderNestedObject(Object.values(imageUrls), result.source.index, result.destination.index);
            setImageUrls(newImageUrls);
            handleReorder(newImageUrls, result.source.index, result.destination.index);
        };
        return (_jsxs(Grid, { container: true, display: 'flex', gap: 1, children: [_jsx(DragDropContext, { onDragEnd: handleDragEnd, children: _jsx(Droppable, { droppableId: "droppable", direction: "horizontal", children: (provided, _snapshot) => (_jsxs(Grid, { item: true, ...provided.droppableProps, sx: { display: 'flex', gap: 1 }, 
                            // needed to maintain equal sizing of the photos
                            xs: Object.keys(imageUrls).length ? Object.keys(imageUrls).length * 4 : 0, ref: provided.innerRef, children: [Object.values(imageUrls).map((url, index) => (_jsx(Draggable, { draggableId: url, index: index, children: (provided, _snapshot) => (_jsx(PhotoCard, { provided: provided, innerRef: provided.innerRef, index: index, url: url, onImageDelete: onImageDelete })) }, url))), provided.placeholder] })) }) }), (Object.keys(imageUrls).length < 3) ? (_jsx(UploadCard, { hasError: hasError, onFileAdd: onFileAdd, handleDrag: handleDrag, dragActive: dragActive, position: Object.keys(imageUrls).length })) : null] }));
    };
    return (_jsx(StyledCard, { isLoading: isLoading, sx: { maxWidth: '1200px' }, children: _jsxs(Paper, { children: [_jsx(CardHeader, { title: 'Photos', subheader: 'Add up to three references so the user understands what they should look for.', subheaderTypographyProps: {
                        variant: 'body2',
                    } }), _jsx(CardContent, { children: _jsx(PhotoHolder, { hasError: hasUploadError }) })] }) }));
};
export default UploadedPhotosCard;
//# sourceMappingURL=index.js.map